import React from 'react';
import TrashCan from '@uber/base-icons/trash-can';
import { styled } from 'baseui';
import { Button, KIND as BTN_KIND, SHAPE, SIZE } from 'baseui/button';
import { Checkbox, LABEL_PLACEMENT, STYLE_TYPE } from 'baseui/checkbox';
import { ShowHideButton } from '../collapsible-panel/trailing-toggle-component/show-hide-button.react';
import { VISIBILITY_ANNOTATION_ACTION } from '../constant/constant';
import type { ToggleRenderAllAnnotationsPayloadT, ToggleVisibilityAllAnnotationsPayloadT } from '../side-panel/analytics/types';
import useAnalyticsForSidePanel from '../side-panel/analytics/useAnalyticsForSidePanel';
import { type StoreTypeT } from '../types/types';
import { FilterContainer } from './filter-container';
const SettingsContainer = styled('div', {
  display: 'flex'
});
const Panel = styled('div', ({
  $theme: {
    colors
  }
}) => ({
  color: colors.contentPrimary,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  cursor: 'pointer',
  flexDirection: 'row-reverse'
}));
const ActionItem = styled('span', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  minWidth: '25px',
  padding: '1px'
});
const TotalAnnotations = styled('span', {
  marginLeft: '14px',
  fontFamily: 'UberMoveText, system-ui, "Helvetica Neue", Helvetica, Arial, sans-serif',
  fontSize: '15px'
});
const TotalAnnotationsCount = styled('span', {
  fontFamily: 'UberMoveText, system-ui, "Helvetica Neue", Helvetica, Arial, sans-serif',
  fontSize: '15px',
  fontWeight: 'bold'
});
const LabelContent = styled('div', ({
  $theme: {
    sizing
  }
}) => ({
  display: 'flex',
  padding: `${sizing.scale200} ${sizing.scale500}`,
  marginRight: '-1px'
}));
type PropsT = {
  isChecked?: boolean;
  isHidden?: boolean;
  count: number;
  handleAllAnnotationsToggle?: (value: boolean) => void;
  onShowHideAllAnnotations?: (hidden: boolean, storeType?: StoreTypeT) => void;
  setLabelMap: (labelMap: {
    [key: string]: boolean;
  }) => void;
  labelMap: {
    [key: string]: boolean;
  };
  handleDeleteAllAnnotations: (currentFrameOnly?: boolean, annotationLabel?: string) => void;
};
const AnnotationGroupSettings = (props: PropsT) => {
  const {
    sendEventForToggleVisibilityAllAnnotations,
    sendEventForToggleRenderAllAnnotations
  } = useAnalyticsForSidePanel();
  const handleShowHideAllAnnotations = (hidden: boolean) => {
    props.onShowHideAllAnnotations?.(hidden);
    let eventPayload: ToggleVisibilityAllAnnotationsPayloadT = {
      action: hidden ? VISIBILITY_ANNOTATION_ACTION.HIDE : VISIBILITY_ANNOTATION_ACTION.SHOW
    };
    sendEventForToggleVisibilityAllAnnotations(eventPayload);
  };
  const handleAllAnnotationsToggle = (checked: boolean) => {
    props.handleAllAnnotationsToggle?.(checked);
    let eventPayload: ToggleRenderAllAnnotationsPayloadT = {
      showAllAnnotationsEnabled: !checked
    };
    sendEventForToggleRenderAllAnnotations(eventPayload);
  };
  const isShowAllAnnotationsEnabled = props.handleAllAnnotationsToggle;
  return <Panel>
      <SettingsContainer>
        <LabelContent>
          <ActionItem>
            <FilterContainer setLabelMap={props.setLabelMap} labelMap={props.labelMap} />
          </ActionItem>
          <ActionItem>
            <ShowHideButton
          // @ts-expect-error missing null check
          hidden={props.isHidden} onClick={hidden => handleShowHideAllAnnotations(hidden)} />
          </ActionItem>
          <ActionItem>
            <Button size={SIZE.mini} onClick={() => isShowAllAnnotationsEnabled && props.isChecked ? props.handleDeleteAllAnnotations(true) : props.handleDeleteAllAnnotations(false)} shape={SHAPE.circle} kind={BTN_KIND.tertiary} overrides={{
            BaseButton: {
              style: ({
                $theme
              }) => ({
                color: $theme.colors.negative
              })
            }
          }} data-e2e-id="delete-all-annotations">
              <TrashCan title="Delete annotation" size={16} />
            </Button>
          </ActionItem>
        </LabelContent>
      </SettingsContainer>
      {isShowAllAnnotationsEnabled ? <Checkbox checked={props.isChecked} checkmarkType={STYLE_TYPE.toggle} onChange={e => handleAllAnnotationsToggle(e.target.checked)} labelPlacement={LABEL_PLACEMENT.right}>
          Current frame
        </Checkbox> : <TotalAnnotations>
          Total Annotations: <TotalAnnotationsCount>{props.count}</TotalAnnotationsCount>
        </TotalAnnotations>}
    </Panel>;
};
export default AnnotationGroupSettings;